export default {
    iconPanel: [
            '<div class="uwr-local-nav-iconpanel uwr-local-nav-positioned-panel">',
                '<ul class="uwr-local-nav-menu-items">',
                '</ul>',
            '</div>'
        ].join(''),
    iconPanelItem: [
            '<li id="{{id}}" ',
                'class="uwr-local-nav-actioned',
                ' {{#active}}uwr-local-nav-active{{/active}} {{#disabled}}uwr-local-nav-disabled{{/disabled}}">',
                '<a class="uwr-local-nav-iconpanel-link" title="{{label}}">',
                    '<span class="{{iconClass}}"></span>',
                '</a>',
            '</li>'
        ].join(''),
    pageGroup: [
            '<div class="uwr-local-nav-pagegroup uwr-local-nav-positioned-panel uwr-local-nav-hidden ',
            '{{#active}}uwr-local-nav-active{{/active}}">',
                '<div class="uwr-local-nav-right-grad"></div>',
                '<div class="uwr-local-nav-hamburger-head">',
                    '<div class="uwr-local-nav-hamburger-icon"></div>',
                '</div>',
                '<div class="uwr-local-nav-panel-container">',
                    '<div class="uwr-local-nav-divider"></div>',
                    '<h3>{{label}}</h3>',
                '</div>',
            '</div>'
        ].join(''),
    pageGroupPanel: [
            '<div>',
                '{{#label}}<h4>{{label}}</h4>{{/label}}',
                '<ul {{#collapsible}}class="uwr-local-nav-collapsible"{{/collapsible}}>',
                '</ul>',
            '</div>'
        ].join(''),
    pageGroupPanelNode: [
            '<li id="{{id}}"',
            'class="',
            '{{#hasChildren}}uwr-local-nav-parent-node uwr-local-nav-collapsed {{/hasChildren}}',
            '{{#disabled}}uwr-local-nav-disabled{{/disabled}}',
            '">',
                '<a title="{{label}}">',
                    '{{#hasChildren}}<span class="uwr-local-nav-collapse-icon"></span>{{/hasChildren}}',
                    '<span>{{label}}</span>',
                '</a>',
                '{{#hasChildren}}<ul class="uwr-local-nav-nested-items"></ul>{{/hasChildren}}',
            '</li>'
        ].join('')
};



//////////////////
// WEBPACK FOOTER
// ./widgets/LocalNavigation/js/localNavigationView.js
// module id = 93
// module chunks = main